import { createFileRoute } from '@tanstack/react-router'
import { RequirePermission } from '@/components/ui/require-permission'
import PartnerListPage from '@/features/partners/partner-list'

export const Route = createFileRoute('/_authenticated/partners/')({
  component: () => (
    <RequirePermission permission='partners.read'>
      <PartnerListPage />
    </RequirePermission>
  ),
})
